import React from 'react';
import {Box, Button, Grid, Typography} from "@mui/material";

/**
 * This component is used to display an empty state.
 * @param props
 * @constructor
 *
 * A full example can be this:
 * <EmptyState title={'No data found. Do something'}/>
 */

export interface EmptyStateProps {
    icon?: any;
    title: string;
    content?: string;
    actionName?: string;
    onClick?: Function;
}

const classes = {
    div: {
        display: 'flex',
        textAlign: 'center',
        justifyContent: 'center',
        width: '100%',
    }
}
const EmptyState = (props: EmptyStateProps) => {
    const handleClick = () => {
        if (props.onClick !== undefined) {
            props.onClick();
        }
    }

    return (
        <Box sx={classes.div}>
            <Grid container spacing={1}>
                {props.icon !== undefined && <Grid item xs={12}>
                    {props.icon}
                </Grid>}
                <Grid item xs={12}>
                    <Typography variant={'h4'}>{props.title}</Typography>
                </Grid>
                {props.content !== undefined && <Grid item xs={12}>
                    <Typography variant={'bodyLarge'}>{props.content}</Typography>
                </Grid>}
                {props.actionName !== undefined && <Grid item xs={12}>
                    <Button size={'large'} onClick={handleClick}>{props.actionName}</Button>
                </Grid>}
            </Grid>
        </Box>
    );
};

export default EmptyState;